module.exports = __webpack_public_path__ + "img/12-4.56dda769.png";